import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";

import Axios from "@/lib/axios-instance";

type APIPayload = {
    button_label?: string;
    is_collect_name?: boolean;
    is_collect_phone_number?: boolean;
    is_marketing_consent?: boolean;
    marketing_consent_text?: string;
    subtitle?: string;
    title?: string;
    status?: boolean;
};

type ResponseType = {
    data: any;
    meta: any;
};

export const AddLeadSettings = async (payload: APIPayload) => {
    try {
        const response = await Axios.post(`/chat_widget_settings/lead_collection`, {
            status: true,
            title: payload.title,
            subtitle: payload.subtitle,
            send_button_label: payload.button_label,
            is_collect_phone_number: payload.is_collect_phone_number,
            is_collect_name: payload.is_collect_name,
            marketing_consent_status: payload.is_marketing_consent,
            marketing_consent_text: payload.marketing_consent_text,
        });
        return response.data;
    } catch (error: any) {
        if (error.response) {
            throw new Error(`${error.response.data?.meta?.message || "An error occurred"}`);
        }
        throw new Error(error.message || "Network Error");
    }
};

export const useAddLeadSettings = () => {
    const queryClient = useQueryClient();
    return useMutation<ResponseType, Error, APIPayload>({
        mutationFn: (payload) => AddLeadSettings(payload),
        onSuccess: (data) => {
            toast.success("Lead Settings Updated Successfully");
            queryClient.invalidateQueries({ queryKey: ["get_widget_settings"] });
            console.log(data);
        },
        onError: (error) => {
            toast.error("Lead Settings Update Failed", {
                description: error.message,
            });
        },
    });
};
